module.exports = __webpack_public_path__ + "static/media/rectangle.0514d183.svg";